module.exports = __webpack_public_path__ + "media/images/icons/outlined/phone-134aed6da5157a4899eb5ff039093076.svg";